import { Map, List } from 'immutable'

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export const selectAmbassador = (state) => state.ambassadors || Map()

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export const selectAmbassadorDetailsData = (state) => selectAmbassador(state).get('data', Map())

/**
 * @param {ReduxState} state redux state
 * @returns {Object | undefined}
 */
export const selectAmbassadorDetailsError = (state) => selectAmbassador(state).get('error')

/**
 * @param {ReduxState} state redux state
 * @returns {boolean}
 * @returns {Boolean}
 */
export const selectAmbassadorProcessing = (state) => selectAmbassador(state).get('processing', false)

/**
 * @param {ReduxState} state redux state
 * @returns {List}
 */
export const selectAmbassadorCampaigns = (state) => selectAmbassador(state).getIn(['campaigns', 'data'], List())

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export const selectAmbassadorCampaignsProcessing = (state) => selectAmbassador(state).getIn(['campaigns', 'processing'], false)

/**
 * @param {ReduxState} state redux state
 * @returns {Object | undefined}
 */
export const selectAmbassadorCampaignsError = (state) => selectAmbassador(state).getIn(['campaigns', 'error'])

/**
 * @param {ReduxState} state redux state
 * @returns {List}
 */
export const selectAmbassadorUpcomingCampaigns = (state) => selectAmbassador(state).getIn(['upcomingCampaigns', 'data'], List())

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export const selectAmbassadorUpcomingCampaignsProcessing = (state) => selectAmbassador(state).getIn(['upcomingCampaigns', 'processing'], false)

/**
 * @param {ReduxState} state redux state
 * @returns {Object | undefined}
 */
export const selectAmbassadorUpcomingCampaignsError = (state) => selectAmbassador(state).getIn(['upcomingCampaigns', 'error'])

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 * @returns {List}
 */
export const selectAmbassadorSignUpsData = (state) => selectAmbassador(state).getIn(['signups', 'data'], List())

/**
 * @param {ReduxState} state redux state
 * @returns {Number}
 */
export const selectAmbassadorTotalSignUps = (state) => selectAmbassador(state).getIn(['signups', 'total'], 0)

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export const selectAmbassadorSignUpsProcessing = (state) => selectAmbassador(state).getIn(['signups', 'processing'], false)

/**
 * @param {ReduxState} state redux state
 * @returns {Object | undefined}
 */
export const selectAmbassadorSignUpsError = (state) => selectAmbassador(state).getIn(['signups', 'error'])

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 * @returns {Map}
 */
export const selectAmbassadorCampaignDetails = (state) => selectAmbassador(state).getIn(['campaignDetails', 'data'], Map())

/**
 * @param {ReduxState} state redux state
 * @returns {Object | undefined}
 */
export const selectAmbassadorCampaignDetailsError = (state) => selectAmbassador(state).getIn(['campaignDetails', 'error'])

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export const selectAmbassadorCampaignDetailsProcessing = (state) => selectAmbassador(state).getIn(['campaignDetails', 'processing'], false)

/**
 * @param {ReduxState} state redux state
 * @returns {List}
 */
export const selectAmbassadorPayouts = (state) => selectAmbassador(state).getIn(['payouts', 'payouts'], List())

/**
 * @param {ReduxState} state redux state
 * @returns {Object | undefined}
 */
export const selectAmbassadorPayoutsError = (state) => selectAmbassador(state).getIn(['payouts', 'error'])

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export const selectAmbassadorPayoutsProcessing = (state) => selectAmbassador(state).getIn(['payouts', 'processing'], false)
